import { useAppShell } from "../AppShellContext";
import MobileNotifBell from "./MobileNotifBell";

export default function TopBar() {
  const { isDark, toggleDark, setActiveTab } = useAppShell();

  const openProfile = () => {
    // Haptic feedback
    if (typeof window !== "undefined" && window.navigator?.vibrate) {
      window.navigator.vibrate(15);
    }
    setActiveTab("you");
  };

  return (
    <header className="hh-topbar">
      <div className="hh-topbar-brand">
        <img src="/healhub-logo-clean.png" alt="" className="hh-topbar-logo" />
        <span className="hh-topbar-name">healhub.space</span>
      </div>
      <div className="hh-topbar-actions">
        <MobileNotifBell />
        <button
          className="hh-topbar-btn"
          onClick={toggleDark}
          aria-label={isDark ? "Light mode" : "Dark mode"}
        >
          {isDark ? "☀️" : "🌙"}
        </button>
        {/* Profile button – replaces bottom "You" tab */}
        <button
          className="hh-topbar-btn profile-btn"
          onClick={openProfile}
          aria-label="Profile"
        >
          👤
        </button>
      </div>
    </header>
  );
}